<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3rHKWV/tc-custom/9781504033947.jpg?1734204041711" alt="This image is the cover for the book Memoir of Col. Benjamin Tallmadge"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Memoir of Col. Benjamin Tallmadge
      </h1>
      <p class="bookDescription body article font2">
        <b>The Revolutionary War colonel—and leader of the famed Culper Spy Ring—tells his story in this fascinating historical autobiography.</b><br/>  <br/> When British troops defeated the Continental Army on Long Island, General George Washington was forced to abandon New York in order to save the revolution. The British established their headquarters in New York City—beginning an occupation that would last the length of the war.<br/>  <br/> Priceless intelligence flowed through the city’s harbor, and Washington wanted to claim it as his own. To Benjamin Tallmadge, a young officer of the Continental Army, the general assigned an impossible mission: Infiltrate New York, establish a spy network, and report everything the British know.<br/>  <br/> Throughout the war, Tallmadge and his spies collected intelligence on troop movements, sneak attacks, and the treachery of Benedict Arnold. Nearly two and a half centuries later, the heroic exploits of the Culper Spy Ring have served as the inspiration for the acclaimed TV series <i>Turn: Washington’s Spies </i>and the video game <i>Assassin’s Creed III</i>. In this lively and engaging memoir, the days of revolution are remembered by a patriot who fought in the shadows—and helped redefine the nature of espionage.<br/><br/><i>This ebook has been professionally proofread to ensure accuracy and readability on all devices.</i><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Benjamin Tallmadge
      </h2>
      
      <p class="authorDescription body article">Benjamin Tallmadge (1754&ndash;1835) was an American revolutionary, congressman, author, and spy. During the Revolutionary War, he founded the Culper Spy Ring, an intelligence network based in New York City, and organized guerilla attacks against the British. Afterward, he settled in Connecticut, and spent sixteen years representing the state in Congress. His memoir was published posthumously in 1858.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6ac3bc09